export default __webpack_public_path__ + "static/media/product-1.36d084f3.jpg";